<template>
    <h2>Edit {{ selectedUser?.displayName }} Profile</h2>
	<div class="user-profile" v-if="selectedUser?.phoneNumber">
		<div class="bottom-spacing grid-display">
			<label class="bold-text">First Name</label>
        	<input
            	type="text"
            	:placeholder="selectedUser?.nameFirst"
            	v-model="firstName"
        	/>
		</div>
        <div class="bottom-spacing grid-display">
			<label class="bold-text">Middle Name</label>
       		<input
            	type="text"
            	:placeholder="selectedUser?.nameLast"
            	v-model="lastName"
     		/>
		</div>
       	<div class="bottom-spacing grid-display">
			<label class="bold-text">Last Name</label>
        	<input
            	type="text"
            	:placeholder="selectedUser?.nameLast2"
            	v-model="nameLast2"
        	/>
	   	</div>
        <div class="bottom-spacing grid-display">
			<label class="bold-text">Birth Date</label>
			<input
				type="date"
				:placeholder="userProfile?.personalInfo?.birthdate"
				v-model="birthDate"
			/>
		</div>
		<div class="bottom-spacing grid-display">
			<label class="bold-text">Address Number</label>
			<input 
				type="text"
				:placeholder="userProfile?.personalInfo?.addressNumber"
				v-model="addressNumber"
			/>
		</div>
		<div class="bottom-spacing grid-display">
			<label class="bold-text">Address Street</label>
			<input 
				type="text"
				:placeholder="userProfile?.personalInfo?.addressStreet"
				v-model="addressStreet"
			/>
		</div>
		<div class="bottom-spacing grid-display">
			<label class="bold-text">City</label>
			<input 
				type="text"
				:placeholder="userProfile?.personalInfo?.addressCity"
				v-model="city"
			/>
		</div>
		<div class="bottom-spacing grid-display">
			<label class="bold-text">Address State</label>
			<input 
				type="text"
				:placeholder="userProfile?.personalInfo?.addressState"
				v-model="addressState"
			/>
		</div>
		<div class="bottom-spacing grid-display">
			<label class="bold-text">Address Zip Code</label>
			<input 
				type="text"
				:placeholder="userProfile?.personalInfo?.addressZipCode"
				v-model="addressZipCode"
			/>
		</div>
		<div class="bottom-spacing grid-display">
			<label class="bold-text">Nationality</label>
			<input
				type="text"
				:placeholder="userProfile?.peronsalInfo?.nationality"
				v-model="nationality"
			/>
		</div>
		<div class="bottom-spacing grid-display">
			<label class="bold-text">Country</label>
			<input 
				type="text"
				:placeholder="userProfile?.personalInfo?.addressCountry"
				v-model="country"
			/>
		</div>
	</div>
	<div style="display: flex; justify-content: center;">
		<button class="btn" @click="changeSelectedUsersProfile()">
       		Edit User Profile
    	</button>
	</div>
</template>

<script>

// Tools from awesome-phonenumber. For now were just using parsePhoneNumber
// https://www.npmjs.com/package/awesome-phonenumber
import {
	parsePhoneNumber,

} from "awesome-phonenumber";
import sharedScripts from "@/dependencies/sharedScripts";
export default {
	name: "EditUserProfile",
	components: {
	},
	props: {
		adminState: Object,
		selectedUser: Object,
		isMobile: Boolean,
		systemSettings: Object,
	},
	data() {
		return {
			status: Object.assign({}, this.globalStatus),
			serverBusy: false,
            userProfile: null,
            firstName: this.selectedUser?.nameFirst,
            lastName: this.selectedUser?.nameLast,
            nameLast2: this.selectedUser?.nameLast2,
			birthDate: null,
			nationality: null,
			city: null,
			country: null,
			addressNumber: null,
			addressState: null,
			addressState: null,
			addressStreet: null,
			addressZipCode: null,
		};
	},
    mounted() {
        this.getUserProfile();
    },
	watch: {
	},
	methods: {

        async getUserProfile() {
            
			let requestUrl = new URL(`/api/v1/user/${this.selectedUser.userId}/profile`, this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState?.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");

			let request = new Request(requestUrl.toString(), {
				method: "GET",
				headers: headerObj,
			});

			try {
				const response = await fetch(request);

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout === true) this.eventBus.emit("forceLogout");
					return;
				}

				let dataJson = await response.json();

				this.userProfile = dataJson;

				if(new Date(this.userProfile?.personalInfo?.birthDate).toISOString().split("T")[0] == new Date(1970,0,1).toISOString().split("T")[0]) this.birthDate = null;
				else this.birthDate = new Date(this.userProfile?.personalInfo?.birthDate).toISOString().split("T")[0];
				
				this.nationality = this.userProfile?.personalInfo?.nationality;
				this.city = this.userProfile?.personalInfo?.addressCity;
				this.country = this.userProfile?.personalInfo?.addressCountry;
				this.addressNumber = this.userProfile?.personalInfo?.addressNumber;
				this.addressState = this.userProfile?.personalInfo?.addressState;
				this.addressStreet = this.userProfile?.personalInfo?.addressStreet;
				this.addressZipCode = this.userProfile?.personalInfo?.addressZipCode;
		
				let mergedSelectedUser = {...this.selectedUser, ...dataJson};
				this.eventBus.emit("updateSelectedUser", mergedSelectedUser);

				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				console.error(e);
				this.status.ok = false;
				this.status.message = "Server not responding to User Profile request";
				this.eventBus.emit("updateStatus", this.status);
				this.serverBusy = false;
				this.busyText = "";
			}
        },

        async changeSelectedUsersProfile() {
            let body = {
				userId: this.selectedUser.userId,
				userProfile: {
					personalInfo: {
						nameFirst: this.firstName,
						nameLast: this.lastName,
						nameLast2: this.nameLast2,
						addressCity: this.city,
						addressCountry: this.country,
						nationality: this.nationality,
						addressNumber: this.addressNumber,
						addressState: this.addressState,
						addressStreet: this.addressStreet,
						addressZipCode: this.addressZipCode,
						birthDate: this.birthDate == null ? new Date(1970,0,1).toISOString().split("T")[0] : this.birthDate,
					},
				},
			};

			let requestUrl = new URL("/api/v1/user/profile", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				const response = await fetch(request).catch(() => {
					this.status.ok = false;
					this.status.message = this.languageErrorStrings.somethingWentWrongTryLater;
					this.eventBus.emit("updateStatus", this.status);
					this.serverBusy = false;
					this.busyText = "";
					return false;
				});

				let fetchStatus = sharedScripts.checkFetchErrors(response, this.languageErrorStrings);

				if (fetchStatus && !fetchStatus.ok) {
					this.eventBus.emit("updateStatus", fetchStatus);
					if (fetchStatus.forceLogout === true) this.eventBus.emit("forceLogout");
					return;
				}

				let dataJson = await response.json();

				if (dataJson?.status === "FailedPersonalInfoValidation") {
					dataJson.validationErrors.forEach((err) => {
						this.status.ok = false;
						if (this.countryCode == "MX") {
							this.handleErrorMessage(err);
						} else {
							this.status.message = `${this.camelToTitleCase(err.field)}: ${this.camelToTitleCase(
								err.reason
							)}`;
						}

						this.eventBus.emit("updateStatus", this.status);
					});
					this.serverBusy = false;
					this.busyText = "";
					return false;
				}

				if (dataJson?.status !== "Success") {
					this.status.ok = false;
					this.status.message = dataJson.status;
					this.eventBus.emit("updateStatus", this.status);
					this.serverBusy = false;
					this.busyText = "";
					return false;
				}

				this.status.ok = true;
				this.status.message = "Personal Info Updated";
				this.eventBus.emit("updateStatus", this.status);
				this.serverBusy = false;
				this.busyText = "";
			} catch (e) {
				console.error(e);
				this.status.ok = false;
				this.status.message = e;
				this.eventBus.emit("updateStatus", this.status);
				this.serverBusy = false;
				this.busyText = "";
			}
        }
        

		
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.user-profile {
    display: grid;
    justify-content: center;
    align-items: center;
	grid-template-columns: repeat(4, 1fr);
}

.bold-text{
	font-weight: bold;
}

.bottom-spacing {
	margin-bottom: 25px;
}

.grid-display {
	display: grid;
}

</style>